module.exports = __webpack_public_path__ + "media/images/team/dominique-07a75345b174930dcb7bd8ec6778f36e.jpg";